import { updateProfileExpandOption } from './updateProfileExpandOption';

export const expandOptions = {
  updateProfileExpandOption,
};
